import Head from 'next/head'
import { useStaticData } from '@mc/static-data-react'

type Course = { slug: string; title: string }

type Metadata = {
  meta: Record<string, string>
  structuredData: [{ '@type': string; [key: string]: string }]
}

const Meta = () => {
  const { course, metadata } = useStaticData<{
    course: Course
    metadata: Metadata
  }>()

  return (
    <Head>
      <title>{course.title}</title>

      {metadata?.meta &&
        Object.entries(metadata.meta).map(
          ([key, value]) =>
            value && <meta key={key} name={key} content={value} />,
        )}

      {metadata?.structuredData &&
        metadata.structuredData.length > 0 &&
        metadata.structuredData.map((entity) => (
          <script
            key={entity['@type']}
            type='application/ld+json'
            dangerouslySetInnerHTML={{ __html: JSON.stringify(entity) }}
          />
        ))}
    </Head>
  )
}

export default Meta
